import React from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '../state'
import { client } from '../../utils'
import { canvasSupportDashboard as endpoints } from '../../api_urls'
import DeleteModal from './DeleteModal'
import EditAssessmentModal from './EditAssessmentModal'
import MoveDeleteCanvasAct from './MoveDeleteCanvasAct'
import AssessmentInfo from './AssessmentInfo'

const Assessment = props => {
  let [currentState, dispatch] = useStateValue()

  let [canvasGroupId, setCanvasGroupId] = React.useState(props.groupId)
  let handleCanvasGroupSelect = e => {
    let newGroupId = Number(e.target.value)
    setCanvasGroupId(newGroupId)
    changeAssessmentNewGroup(newGroupId)
  }

  let changeAssessmentNewGroup = newGroupId => {
    let currentGroup = currentState.groups.find(
      group => group.id === props.groupId
    )
    let currentAct = currentGroup.acts.find(act => act[0] === props.id)
    let newGroupActs = currentState.groups.find(
      group => group.id === Number(newGroupId)
    ).acts
    newGroupActs.push(currentAct)
    currentGroup.acts = currentGroup.acts.filter(act => act[0] !== props.id)
    dispatch({ type: 'UPDATE_GROUPS', payload: currentState.groups })
  }

  let mapAssessment = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    let url = endpoints.mapAssessment()
    let data = {
      actPk: currentState.acts.find(act => act.id === props.id).mappedAct[1][0],
      canvasId: props.id,
      canvasGroupId: props.groupId,
      previousActPk: currentState.acts.find(act => act.id === props.id)
        .savedMappedAct[1][0],
    }
    let resp = await client.post(url, data)
    dispatch({
      type: 'MAPPED_ASSESSMENT_CHANGE',
      myedGroups: resp.data.myedGroups,
      acts: resp.data.canvasActs,
      myedActs: resp.data.myedActs,
    })
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let editAssessment = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    let url = endpoints.editAssessment()
    let data = {
      canvasActId: props.id,
    }
    if (name !== props.title) {
      data['assignment[name]'] = name
    } else {
      openCloseActModal()
      return
    }
    let resp = await client.post(url, data)
    dispatch({ type: 'UPDATE_ACTS', payload: resp.data.canvasActs })
    openCloseActModal()
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let deleteAssessment = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    let url = endpoints.deleteAssessment()
    let data = {
      actPk: currentState.acts.find(act => act.id === props.id).mappedAct[1][0],
      canvasId: props.id,
    }
    let resp = await client.post(url, data)
    dispatch({ type: 'UPDATE_GROUPS', payload: resp.data.canvasGroups })
    dispatch({ type: 'UPDATE_ACTS', payload: resp.data.canvasActs })
    dispatch({ type: 'UPDATE_MYED_GROUPS', payload: resp.data.myedGroups })
    dispatch({ type: 'UPDATE_MYED_ACTS', payload: resp.data.myedActs })
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let [modalOpen, setModalOpen] = React.useState(false)
  let openCloseModal = () => {
    setModalOpen(!modalOpen)
  }

  let [actModalOpen, setActModalOpen] = React.useState(false)
  let openCloseActModal = () => {
    setActModalOpen(!actModalOpen)
  }

  let [name, setName] = React.useState(props.title)
  let handleNameChange = e => {
    setName(e.target.value)
  }

  let handleGroupSelect = e => {
    let myedGroup = currentState.myedGroups.find(
      group => group[0] === e.target.value
    )
    let mappedGroupAct = currentState.acts.find(
      act => act.id === props.id
    ).savedMappedAct
    let newGroup = [myedGroup[0], myedGroup[1]]
    if (myedGroup[0] === mappedGroupAct[0][0]) {
      dispatch({
        type: 'UPDATE_MAPPED_ACT',
        actId: props.id,
        mappedAct: mappedGroupAct,
      })
    } else {
      dispatch({
        type: 'UPDATE_MAPPED_ACT',
        actId: props.id,
        mappedAct: [newGroup, ['', '------']],
      })
    }
  }

  let handleActSelect = e => {
    let act = currentState.acts.find(act => act.id === props.id)
    let myedAct = currentState.myedActs.find(act => act[0] === e.target.value)
    if (myedAct == null) {
      myedAct = act.savedMappedAct[1]
    }
    let mappedGroupAct = act.mappedAct
    dispatch({
      type: 'UPDATE_MAPPED_ACT',
      actId: props.id,
      mappedAct: [mappedGroupAct[0], [myedAct[0], myedAct[1]]],
    })
  }

  let getMyedActs = () => {
    let options = []
    let act = currentState.acts.find(act => act.id === props.id)
    let mappedAct = act.mappedAct
    let savedMappedAct = act.savedMappedAct
    let myedGroupActIds = currentState.myedGroups.find(
      group => group[0] === mappedAct[0][0]
    )[2]
    myedGroupActIds.map(id => {
      let myedAct = currentState.myedActs.find(act => act[0] === id)
      if (myedAct[0] !== mappedAct[1][0]) {
        options.push(<option value={myedAct[0]}>{myedAct[1]}</option>)
      }
    })
    if (savedMappedAct[1][0] !== mappedAct[1][0]) {
      options.push(
        <option value={savedMappedAct[1][0]}>{savedMappedAct[1][1]}</option>
      )
    }
    return options
  }

  return (
    <div className="border my-4 px-4 grab bg-white">
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <h4>{props.title}</h4>
          <button
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed ml-5 mt-2"
            onClick={openCloseActModal}
          >
            Edit
          </button>
        </div>
        <div>
          <span>
            MyEd Group:
            <select
              value={
                currentState.acts.find(act => act.id === props.id)
                  .mappedAct[0][0]
              }
              className="mx-3"
              onChange={handleGroupSelect}
            >
              <option
                value={
                  currentState.acts.find(act => act.id === props.id)
                    .mappedAct[0][0]
                }
                key={
                  currentState.acts.find(act => act.id === props.id)
                    .mappedAct[0][0]
                }
              >
                {
                  currentState.acts.find(act => act.id === props.id)
                    .mappedAct[0][1]
                }
              </option>
              {currentState.myedGroups.map(group => {
                if (
                  group &&
                  group[0] !==
                    currentState.acts.find(act => act.id === props.id)
                      .mappedAct[0][0]
                ) {
                  return (
                    <option value={group[0]} key={group[0]}>
                      {group[1]}
                    </option>
                  )
                }
              })}
            </select>
          </span>
          {currentState.acts.find(act => act.id === props.id)
            .mappedAct[0][0] ? (
            <span className="ml-3">
              MyEd Activity:
              <select
                value={
                  currentState.acts.find(act => act.id === props.id)
                    .mappedAct[1][0]
                }
                className="ml-3"
                onChange={handleActSelect}
              >
                <option
                  value={
                    currentState.acts.find(act => act.id === props.id)
                      .mappedAct[1][0]
                  }
                  key={
                    currentState.acts.find(act => act.id === props.id)
                      .mappedAct[1][0]
                  }
                >
                  {
                    currentState.acts.find(act => act.id === props.id)
                      .mappedAct[1][1]
                  }
                </option>
                {getMyedActs()}
              </select>
            </span>
          ) : null}
          <button
            className="btn btn-myed btn-success-myed btn-success btn-sm-myed ml-5 mt-2"
            disabled={
              (currentState.acts.find(act => act.id === props.id)
                .mappedAct[0][0] ===
                currentState.acts.find(act => act.id === props.id)
                  .savedMappedAct[0][0] &&
                currentState.acts.find(act => act.id === props.id)
                  .mappedAct[1][0] ===
                  currentState.acts.find(act => act.id === props.id)
                    .savedMappedAct[1][0]) ||
              currentState.acts.find(act => act.id === props.id)
                .mappedAct[1][0] === ''
            }
            onClick={mapAssessment}
          >
            Update Mapping
          </button>
        </div>
      </div>
      <MoveDeleteCanvasAct
        canvasGroupId={canvasGroupId}
        handleCanvasGroupSelect={handleCanvasGroupSelect}
        openCloseModal={openCloseModal}
      />
      <AssessmentInfo
        id={props.id}
        dueAt={props.dueAt}
        pointsPossible={props.pointsPossible}
        unlockAt={props.unlockAt}
        lockAt={props.lockAt}
        createdAt={props.createdAt}
        published={props.published}
        subTypes={props.subTypes}
      />
      <DeleteModal
        modalOpen={modalOpen}
        openCloseModal={openCloseModal}
        actPk={
          currentState.acts.find(act => act.id === props.id).mappedAct[1][0]
        }
        canvasId={props.id}
        deleteAct={deleteAssessment}
      />
      <EditAssessmentModal
        actModalOpen={actModalOpen}
        openCloseActModal={openCloseActModal}
        name={name}
        handleNameChange={handleNameChange}
        editAct={editAssessment}
      />
    </div>
  )
}

export default Assessment

Assessment.propTypes = {
  title: PropTypes.string,
  id: PropTypes.number,
  dueAt: PropTypes.string,
  unlockAt: PropTypes.string,
  lockAt: PropTypes.string,
  createdAt: PropTypes.string,
  pointsPossible: PropTypes.number,
  published: PropTypes.bool,
  workflowState: PropTypes.string,
  subTypes: PropTypes.array,
  mappedAct: PropTypes.array,
  groupId: PropTypes.number,
  groupName: PropTypes.string,
}
